import React from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../../components/FontAwesomeIcons";
import {USER_EVENT_TYPE_PHOTO_ALBUM, USER_EVENT_TYPE_RESERVATIONS} from "./CreateEventConstants";

export class CreateEventTypeStep extends React.Component {
    constructor(props) {
        super(props);
        this.iconStyle = {
            width: "82px",
            minWidth: "82px",
            height: "82px",
            fontSize: "34px",
        };
    }

    handleChoose = type => _ => this.props.onChoose(type)

    render() {
        return (
            <div className={"container"}>
                <div className={"my-4 text-center"}>
                    <h4 className={"font-weight-bold mb-1"}>Che tipo di evento vuoi creare?</h4>
                    <div className={"text-muted"}>Scegli il flusso più adatto e inizia a configurarlo.</div>
                </div>

                <div className={"card border-0 shadow-sm mb-3"} onClick={this.handleChoose(USER_EVENT_TYPE_RESERVATIONS)}>
                    <div className={"card-body"}>
                        <div className={"d-flex align-items-center"}>
                            <div
                                className={"rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mr-3"}
                                style={this.iconStyle}
                            >
                                <FaSolidIcon name={"user-check"}/>
                            </div>
                            <div>
                                <h5 className={"font-weight-bold mb-2"}>Raccolta adesioni</h5>
                                <p className={"text-muted mb-0"}>
                                    Crea una landing per gli invitati e raccogli conferme, partecipanti e preferenze.
                                </p>
                            </div>
                        </div>
                        <div className={"text-right mt-3"}>
                            <span className={"btn btn-link text-primary font-weight-bold p-0"}>
                                Inizia <FaSolidIcon name={"chevron-right"} className={"ml-1"}/>
                            </span>
                        </div>
                    </div>
                </div>

                <div className={"card border-0 shadow-sm mb-3"} onClick={this.handleChoose(USER_EVENT_TYPE_PHOTO_ALBUM)}>
                    <div className={"card-body"}>
                        <div className={"d-flex align-items-center"}>
                            <div
                                className={"rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mr-3"}
                                style={this.iconStyle}
                            >
                                <FaSolidIcon name={"images"}/>
                            </div>
                            <div>
                                <h5 className={"font-weight-bold mb-2"}>Album fotografico condiviso</h5>
                                <p className={"text-muted mb-0"}>
                                    Prepara un album con QR code per raccogliere le foto caricate durante l'evento.
                                </p>
                            </div>
                        </div>
                        <div className={"text-right mt-3"}>
                            <span className={"btn btn-link text-primary font-weight-bold p-0"}>
                                Inizia <FaSolidIcon name={"chevron-right"} className={"ml-1"}/>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CreateEventTypeStep.propTypes = {
    onChoose: PropTypes.func,
};
